import { observer } from 'mobx-react-lite'
import { makeTextFieldClear, TextField } from 'shared/ui/TextField'
import { useClickToTextListContext } from 'pages/clickToText/pages/all/context'
import styles from './styles.module.scss'

export const Search = observer(() => {
  const { search, setSearch } = useClickToTextListContext()

  return (
    <div className={styles.wrap}>
      <TextField
        className={styles.search}
        variant='integrated'
        InputProps={{
          placeholder: 'Search...',
        }}
        onChange={setSearch}
        value={search}
        ariaLabel='TableSearch'
        rightActions={[
          makeTextFieldClear({
            isButton: true,
            isVisibleWithoutFocus: true,
            intent: 'passive',
          }),
        ]}
      />
    </div>
  )
})
